import { Routes } from '@angular/router';
import { TycPageComponent } from './ui/track-your-captain/view/tyc-page/tyc-page.component';
import { UserAgreementPageComponent } from './ui/user-agreement/view/user-agreement-page/user-agreement-page.component';
import { serviceAgreementGuard } from './guards/service-agreement.guard';
import { NoJobIdPageComponent } from './ui/no-job-id/view/no-job-id-page/no-job-id-page.component';
import { jobIdFormatGuard } from './guards/job-id-format.guard';

export const routes: Routes = [
  { path: 'terms/:jobId', component: UserAgreementPageComponent, canActivate: [jobIdFormatGuard] },
  { path: 'terms', component: UserAgreementPageComponent, canActivate: [jobIdFormatGuard] },
  {
    path: 'tracking/:jobId',
    component: TycPageComponent,
    canActivate: [serviceAgreementGuard],
  },
  {
    path: 'tracking',
    component: TycPageComponent,
    canActivate: [serviceAgreementGuard],
  },
  {
    path: "no-job-id",
    component: NoJobIdPageComponent
  },
  { path: '', component: NoJobIdPageComponent, pathMatch: 'full' },
  { path: '**', component: NoJobIdPageComponent },
];
